export type TestIds =
  | 'AccommodationMap.root'
  | 'ActivityCard.link'
  | 'ActivityCard.root'
  | 'AddedToCart.view-cart'
  | 'AddedToCart.view-more'
  | 'AddressField.address-action'
  | 'AddressField.address-field1'
  | 'AddressField.address-field2'
  | 'AllBeachSectionsDisabledModal.root'
  | 'BeachSection.Recommendations.list'
  | 'BeachChairRowsError.message'
  | 'BookingDetails.root'
  | 'BookingsEmptyState.cta'
  | 'BookingTitle.name'
  | 'Breadcrumbs.root'
  | 'CancelationForm.cancelation-reason'
  | 'CancelationForm.submit'
  | 'CancelationOverview.submit'
  | 'Cart.mixed-currencies'
  | 'Cart.title'
  | 'CartCurrencyMismatchBox.root'
  | 'CartEmpty.root'
  | 'CartItemHeader.traveller'
  | 'CartItem.actions'
  | 'CartItem.cancelation-deadline'
  | 'CartItem.delete'
  | 'CartItem.edit'
  | 'CartItem.error-message'
  | 'CartItem.phone-number'
  | 'CartItem.price'
  | 'CartItem.root'
  | 'CartItem.start-date'
  | 'CartItem.title'
  | 'CartItem.tourist-tax'
  | 'CartList.list'
  | 'CartSummary.root'
  | 'CartSummary.total'
  | 'CategoryPriceLabel.title'
  | 'CheckoutSuccess.root'
  | 'CheckoutSuccess.title'
  | 'CheckoutSuccess.confirmation'
  | 'CheckoutSuccess.itemsList'
  | 'CheckoutSuccess.item'
  | 'CheckoutSuccess.item.status'
  | 'CheckoutSuccess.item.title'
  | 'CheckoutSuccess.item.description'
  | 'CheckoutSuccess.discoverMoreCTA'
  | 'CheckoutSuccess.appTeaser'
  | 'CheckoutSuccess.appTeaser.cta'
  | 'CheckoutSuccess.trustElementConfig'
  | 'ContactGuide.contact-action'
  | 'CTABox.checkout-cta'
  | 'DeleteProfileForm.password'
  | 'DeleteProfileForm.submit'
  | 'DeleteProfileForm.error-future-bookings'
  | 'DeleteProfileForm.bookings-cta'
  | 'DetailsContent.root'
  | 'DiscoverModal.activities-panel'
  | 'DiscoverModal.activities-tab'
  | 'DiscoverModal.locations-panel'
  | 'DiscoverModal.locations-tab'
  | 'DropIn.methods'
  | 'DropIn.root'
  | 'DropIn.submit'
  | 'ExperienceBookingBox.cta'
  | 'ExperienceBookingBox.date-label'
  | 'ExperienceBookingBox.date'
  | 'ExperienceBookingBox.pax-label'
  | 'ExperienceBookingBox.pax'
  | 'ExperienceBookingCancelation.cancel-action'
  | 'ExperienceBookingMeetingPoint.maps-action'
  | 'ExperienceBookingOverview.date'
  | 'ExperienceBookingOverview.edp-link'
  | 'ExperienceOffersFilter.date'
  | 'ExperienceOffersFilter.person'
  | 'ExperienceOffersListItem.add-to-cart'
  | 'ExperienceOverview.cancelation-info'
  | 'ExperiencePrices.option'
  | 'ExperiencePrices.root'
  | 'ExperiencePrices.variant'
  | 'ExperiencesFilter.date'
  | 'ExperienceTitle.title'
  | 'ExperienceReviewCard.comment'
  | 'Footer.root'
  | 'FooterLegal.meta'
  | 'GuestSignup.email-field'
  | 'GuestSignup.first-name-field'
  | 'GuestSignup.last-name-field'
  | 'GuestSignup.newsletter'
  | 'GuestSignup.submit'
  | 'Header.becomeAMerchant'
  | 'Header.wishlist'
  | 'Header.cart'
  | 'Header.logo'
  | 'Header.profile'
  | 'Header.search'
  | 'Homepage.search'
  | 'Search.location-input'
  | 'Search.location-option'
  | 'Search.submit'
  | 'HeroVideo.modal-trigger'
  | 'CartBillingAddress.root'
  | 'BillingFields.root'
  | 'PaxPicker.child-age-select'
  | 'PaxPicker.root'
  | 'PaxPicker.rooms'
  | 'AccommodationPeopleDetails.root'
  | 'InactiveBookingCard.info'
  | 'InactiveBookingCard.title'
  | 'InactiveBookings.list'
  | 'LocationBeachTeaser.cta'
  | 'LocationBeachTeaser.heading'
  | 'LocationCard.content'
  | 'LocationCard.cta'
  | 'LocationExperienceListContainer.load-more-experiences-action'
  | 'LocationExperiencesList.count'
  | 'LocationExperiencesList.list'
  | 'Locations.list'
  | 'DestinationDiscoveryList.link'
  | 'LoginContainer.email'
  | 'LoginContainer.forgot-password'
  | 'LoginContainer.go-to-signup'
  | 'LoginContainer.password'
  | 'LoginContainer.submit'
  | 'MainSection.title'
  | 'NewPasswordForm.password'
  | 'NewPasswordForm.submit'
  | 'NewsletterSignup.root'
  | 'NewsletterSignup.title'
  | 'NewsletterSignup.form'
  | 'PersonSelect.item'
  | 'PersonSelect.option'
  | 'PreviewBadge.root'
  | 'PriceCategoryCount.count'
  | 'PriceCategoryCount.root'
  | 'Profile.bookings-action'
  | 'Profile.general-action'
  | 'Profile.logout-action'
  | 'ProfileGeneral.delete-account'
  | 'ProfileGeneral.name-action'
  | 'ProfileGeneral.name-field'
  | 'ProfileGeneral.phone-action'
  | 'ProfileGeneral.phone-field'
  | 'RegisterContainer.email'
  | 'RegisterContainer.first-name'
  | 'RegisterContainer.last-name'
  | 'RegisterContainer.newsletter'
  | 'RegisterContainer.password'
  | 'RegisterContainer.submit'
  | 'RegistrationTeaser.register-action'
  | 'ResetPasswordForm.email'
  | 'ResetPasswordForm.submit'
  | 'SelectedChairsList.root'
  | 'SelectionErrorMessage.message'
  | 'SelectionFooterMobile.cta'
  | 'SelectionFooterMobile.root'
  | 'SelectionFooterMobile.toggle'
  | 'SelectionSidebarDesktop.cta'
  | 'SeoContent.rich-text'
  | 'SuggestionCard.link'
  | 'SuggestionCard.title'
  | 'SuggestionList.gallery'
  | 'SuggestionList.view-all.desktop'
  | 'SuggestionList.view-all.mobile'
  | 'TopExperiences.root'
  | 'UpcomingBookingCard.date'
  | 'UpcomingBookingCard.title'
  | 'UpcomingBookings.list'
  | 'UserAddressForm.city'
  | 'UserAddressForm.street-number'
  | 'UserAddressForm.street'
  | 'UserAddressForm.submit'
  | 'UserAddressForm.zip-code'
  | 'UserNameForm.first-name'
  | 'UserNameForm.last-name'
  | 'UserNameForm.submit'
  | 'UserPhoneForm.phone'
  | 'UserPhoneForm.submit'
  | 'MerchantDetails.open-modal-action'
  | 'MerchantModal.root'
  | 'AccommodationAvailableRooms.Container'
  | 'AccommodationAvailableRoom.Container'
  | 'AccommodationAvailableRoom.showDetails'
  | 'AccommodationAvailableRoom.addToCart'
  | 'FacilitiesModal.showAll'
  | 'FacilitiesModal.facilityTypes'
  | 'AccommodationBookingBox.container'
  | 'AccommodationBookingBox.paxButton'
  | 'AccommodationBookingBox.dateButton'
  | 'AddedToCart.close'
  | 'RateCard.button'
  | 'ProductListingPageContent.count'
  | 'AccommodationRoomsFilterChips.paxButton'
  | 'ExperienceOffersFilter.variant'
  | 'ExperienceBookingBox.variant-label'
  | 'ExperienceBookingBox.variant'
  | 'VariantSelect.item'
  | 'ExperienceSubtitle.root'
  | 'RatesList.list'
  | 'Rates.rate'
  | 'RoomPickerSummary.addToCart'
  | 'AccommodationFields.firstName'
  | 'AccommodationFields.lastName'
  | 'WishlistToggleCTA'
  | 'ExperienceBookingBox.container'
  | 'HeroMobile'
  | 'WishlistItem.root'
  | 'WishlistItem.name'
  | 'WishlistItem.subline'
  | 'WishlistsList.title'
  | 'WishlistEmpty.root'
  | 'WishlistList.title'
  | 'BeachChairsTeaser.cta'
  | 'BeachChairsTeaser.heading'
  | 'ProductFilters.show-filters'
  | 'FilterModal.section'
  | 'MultiSelectFilterSection.container'
  | 'MultiSelectFilterSection.option'
  | 'MultiSelectFilterSection.showMore'
  | 'RangeFilterSection.container'
  | 'FilterSummary.filter-chip'
  | 'Map.Accommodations.listItem'
  | 'CartItem.mobile-number'
  | 'CartItem.note'
  | 'DateModalContent.message'
  | 'AccommodationDiscount.price'
  | 'AccommodationDiscount.flag'
  | 'AccommodationBookingBox.pricePerNight'
  | 'AccommodationBookingBox.totalPrice'
  | 'AccommodationBookingBoxMobile.title'
  | 'BeachChairBookingBoxDesktop.container'
  | 'BeachChairBookingBoxDesktop.title'
  | 'BeachChairBookingBoxDesktop.dateButton'
  | 'BeachChairBookingBoxDesktop.ctaButton'
  | 'BikeBookingBoxDesktop.container'
  | 'BikeBookingBoxDesktop.startingPrice'
  | 'BikeBookingBoxDesktop.totalPrice'
  | 'BikeBookingBoxDesktop.totalCount'
  | 'BikeBookingBoxDesktop.shopName'
  | 'BikeBookingBoxDesktop.pickBikeCTA'
  | 'BikeBookingBoxDesktop.cartCTA'
  | 'BikeBookingBoxMobile.container'
  | 'BikeBookingBoxMobile.totalPrice'
  | 'BikeBookingBoxMobile.totalCount'
  | 'BikeBookingBoxMobile.cartCTA'
  | 'BikeBookingBoxDesktop.cancellationInfo'
  | 'BikeProductSection.root'
  | 'BikeAmountPicker.increase'
  | 'BikeAmountPicker.decrease'
  | 'BikeAmountPicker.value'
  | 'LocationCombobox.textField'
  | 'SearchModal.locationCard'
  | 'SearchModal.dateCard'
  | 'ShopBookingResponseErrors.refusalReason'
  | 'ShopBookingResponseErrors.BookingFailed'
  | 'ShopBookingResponseErrors.BookingFailedWithReason'
  | 'ShopBookingResponseErrors.BookingInProgress'
  | 'ShopBookingResponseErrors.BookingInProgressWithReason'
  | 'ShopBookingResponseErrors.CartEmpty'
  | 'ShopBookingResponseErrors.CartEmptyWithReason'
  | 'ShopBookingResponseErrors.InvalidCartItems'
  | 'ShopBookingResponseErrors.InvalidCartItemsWithReason'
  | 'ShopBookingResponseErrors.PaymentCanceled'
  | 'ShopBookingResponseErrors.PaymentCanceledWithReason'
  | 'ShopBookingResponseErrors.PaymentFailed'
  | 'ShopBookingResponseErrors.PaymentFailedWithReason'
  | 'RedeemPromoCode.root'
  | 'RedeemPromoCode.applyCode'
  | 'RedeemPromoCode.showInput'
  | 'RedeemPromoCode.inputWrapper'
  | 'RedeemPromoCode.promoCodeInfo'
  | 'PromoCodeModal.text'
  | 'PromoCode.discountRowPrice'
  | 'PromoCode.discountRowName'
  | 'FilterCountChip.badge'
  | 'MapContainer.root'
  | 'MapContainer.sidebar'
  | 'MapContainer.sidebarToggle'
  | 'MapContainer.mapWrapper'
  | 'MapContainer.bottomSheet'
  | 'Map.root'
  | 'Map.pin'
  | 'Map.cluster'
  | 'Map.popup'
  | 'Map.previewCard'
  | 'Map.previewCardSlider'
  | 'Map.chips.root'
  | 'Map.chips.accommodation'
  | 'Map.chips.experience'
  | 'Map.chips.beachSection'
  | 'Map.chips.bike'
  | 'Map.locationFilter'
  | 'AccommodationDateFilter.chip'
  | 'Map.paxFilter'
  | 'Map.pagination.root'
  | 'Map.pagination.loadMore'
  | 'BottomSheet.root'
  | 'BottomSheet.handle'
  | 'BottomSheet.title'
  | 'BottomSheet.content'
  | 'BottomSheet.showMapButton'
  | 'Map.Accommodations.list'
  | 'Map.Experiences.list'
  | 'Map.BeachSections.list'
  | 'Map.Bikes.list'
  | 'PreviewCard.root'
  | 'PreviewCard.close'
  | 'PreviewCard.image'
  | 'PreviewCard.content'
  | 'Map.Products.title'
  | 'Map.pagination.previousButton'
  | 'Map.pagination.nextButton'
  | 'Map.Accommodations.title'
  | 'Map.Experiences.title'
  | 'Map.BeachSections.title'
  | 'Map.Bikes.title'
  | 'DateModalContent.NoRoomsAvailable'
  | 'BodyHeightContent.bodyHeight'
  | 'BikeAmountPicker.root'
  | 'RentableFields.reuseCheckbox'
  | 'AddedToCart.to-checkout'
  | 'ExperienceFields.reuseCheckbox'
  | 'AccommodationFields.reuseCheckbox'
  | 'ExperienceHighlights.description'
  | 'ExperienceHighlights.readDescription'
  | 'PaymentPriorityHint.root'
  | 'PaymentPriorityHint.wallet'
  | 'PaymentPriorityHint.info'
  | 'PaymentPriorityHint.tooltip'

export const shopTestId = (testId: TestIds) => testId
